import React from "react";

import { figureColumn } from "./figureColumn";
import DataTableColumnHeader from "../../../dataTable/DataTableColumnHeader";
import { statusColumn } from "../../../dataTable/dataTableColumns";
import DataTableLinkCell from "../../../dataTable/DataTableLinkCell";
import { getOfferEditHref } from "../../../offers/tableParams/offerColumns";

import type { TFunction } from "i18next";

import type { SubscriptionRow } from "./subscriptionColumns.types";
import type { DataTableColumnDef } from "../../../dataTable/dataTable.types";

interface SubscriptionColumnsOptions {
  t: TFunction;
  projectSlug: string;
  canWrite: boolean;
}

export function getSubscriptionHref(
  row: SubscriptionRow,
  projectSlug: string,
  canWrite: boolean,
): string | undefined {
  return canWrite ? getOfferEditHref(projectSlug, row.uuid) : undefined;
}

export function subscriptionColumns({
  t,
  projectSlug,
  canWrite,
}: SubscriptionColumnsOptions): DataTableColumnDef<SubscriptionRow>[] {
  return [
    statusColumn<SubscriptionRow>("status", t("offer_status"), [
      { value: "active", label: t("table:status.active"), tone: "success" },
      { value: "stop", label: t("table:status.stop"), tone: "error" },
    ]),
    {
      accessorKey: "offer_label",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("offer_label")} />
      ),
      meta: { searchable: true, label: t("offer_label") },
      cell: ({ row }) => (
        <DataTableLinkCell
          href={getSubscriptionHref(row.original, projectSlug, canWrite)}
        >
          {row.original.offer_label}
        </DataTableLinkCell>
      ),
    },
    figureColumn("sales", t("sales"), { width: "17%", minWidth: 140 }),
    figureColumn("total_subscription_gift", t("subscription_gift"), {
      width: "17%",
      minWidth: 100,
    }),
    figureColumn("total_subscription_freecopy", t("subscription_freecopy"), {
      width: "17%",
      minWidth: 185,
    }),
  ];
}
